<template>
  <div class="company-introduction">
    <ucar-title>{{title}}</ucar-title>
    <ucar-img-header type="company-index" :company-name="companyName"></ucar-img-header>
    <introduction-header
      type="company"
      :title="type === 'nocar' ? '企业无车优驾司机' : '企业带车优驾司机'"
      :desc="`关于${vuexCompanyName}`"
      :modal-title="vuexCompanyName"
      :modal-desc="companyIntroduction">
    </introduction-header>
    <div class="introduction-advantage">
      <h3>企业招募优势</h3>
      <ul v-if="advantageList && advantageList.length > 0">
        <li :key="item" v-for="item in advantageList">{{item}}</li>
      </ul>
    </div>
    <introduction-require title="无车加入方式" :list="instructionList" v-if="type === 'nocar'"></introduction-require>
    <introduction-require title="司机要求" :list="vuexCurrentCity.driverRequire"></introduction-require>
    <introduction-require title="车辆要求" :list="vuexCurrentCity.carRequire" v-if="type !== 'nocar'"></introduction-require>
    <introduction-process title="招募流程" :list="process"></introduction-process>
    <introduction-contact title="报名咨询" :cityId="vuexCurrentCity.cityId" v-if="vuexCurrentCity.cityId!==''"></introduction-contact>
    <ucar-submit v-if="mode === 'normal'" @click.native="goLogin">立即报名</ucar-submit>
  </div>
</template>

<script>
import { companyRegProcessForNocar, companyRegProcessForHascar, loginStatus } from '../../utils/constants'
import introductionHeader from '../../components/introduction-header'
import introductionRequire from '../../components/introduction-require'
import introductionProcess from '../../components/introduction-process'
import introductionContact from '../../components/introduction-contact'
import { getCompanyInfo } from '../../api'

export default {
  data () {
    return {
      title: '...',
      mode: 'normal',
      type: 'nocar',
      companyName: '',
      companyIntroduction: '',
      advantageList: [],
      instructionList: [],
      process: []
    }
  },
  components: {
    introductionHeader,
    introductionRequire,
    introductionProcess,
    introductionContact
  },
  created () {
    this.type = this.$route.query.type
    if (this.$route.query.mode) this.mode = this.$route.query.mode
    if (this.type !== 'nocar') {
      this.title = '企业带车优驾司机'
      this.process = companyRegProcessForHascar
    } else {
      this.title = '企业无车优驾司机'
      this.process = companyRegProcessForNocar
    }
  },
  methods: {
    goLogin () {
      this.setVuexDriverType('2')
      this.type === 'hascar' ? this.setVuexOwnCarJoin(true) : this.setVuexOwnCarJoin(false)
      if (this.loginStatus === loginStatus.fillInfo) {
        this.vuexNewRecruit ? this.$router.push('/new-driver-info') : this.$router.push('/driver-info')
      } else {
        this.$router.push('/login?joinMode=join')
      }
    }
  },
  mounted () {
    getCompanyInfo(this.vuexCompanyId)
      .then(res => {
        this.setVuexCompanyName(res.companyName)
        this.companyIntroduction = res.companyProfile || '暂无该公司介绍说明'
        this.advantageList = res.advantageList
        this.instructionList = res.instruction.split('\n')
      })
  }
}
</script>

<style lang="stylus" scoped>
@import "../../styles/variable.styl";

.company-introduction {
  .introduction-advantage {
    margin-bottom: 20px;
    padding: 40px;
    line-height: 1;
    background-color: #fff;
    color: $ucar_font_color;

    h3 {
      margin-bottom: 30px;
      text-align: center;
      font-size: $ucar_font_h4;
      font-weight: bold;
    }

    ul {
      padding-left: 0;

      li {
        list-style: none;
        font-size: $ucar_font_h6;
        line-height: 1.5;
        text-align: center;
        margin-bottom: 15px;
      }
    }
  }
}
</style>
